import DEFAULT_SETTINGS, { DefaultSettings } from '../defaultSettings';

export default DEFAULT_SETTINGS as DefaultSettings;
